import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const useCustomNavigate = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentSource = useMemo(
    () => location.pathname.split("/")[1],
    [location.pathname]
  );
  const navigateTo = (updateContactRoute: string) => {
    navigate(`/${currentSource}/${updateContactRoute}`);
  };

  return {
    navigateTo,
    currentSource,
  };
};
